// Utility Functions
function hideApp() {
    document.getElementById('app').style.display = 'none';
    document.body.classList.remove('overlay');
    console.log("App hidden");
}

function showApp() {
    document.getElementById('app').style.display = 'block';
    document.body.classList.add('overlay');
    console.log("App shown");
}

// Check login status on page load
async function checkLoginStatus() {
    const isLoggedIn = localStorage.getItem("isLoggedIn");
    console.log("Login status:", isLoggedIn);

    if (isLoggedIn === "true") {
        // User is logged in
        hideApp();
        document.getElementById("welcome-message").style.display = "block";
        document.getElementById("customer-form").style.display = "none";
    } else {
        // User is not logged in
        showApp();
        document.getElementById("customer-form").style.display = "block";
        document.getElementById("welcome-message").style.display = "none";
    }
}

// Handle form submission
document.getElementById("customer-form").addEventListener("submit", async function(e) {
    e.preventDefault();

    const phoneNumber = document.getElementById("customer-phone").value.trim();
    if (!phoneNumber) {
        alert("Please enter a valid phone number.");
        return;
    }

    try {
        console.log("Submitting phone number:", phoneNumber);

        // Send the phone number to the backend
        const response = await axios.post("https://advanceayurveda.in/popup_data/customer_handler.php", { phone: phoneNumber });

        console.log("Server response:", response.data);

        if (response.data.success) {
            if (response.data.customerId) {
                // Existing user
                hideApp();
                localStorage.setItem("isLoggedIn", "true");
                alert("Welcome back!");
            } else {
                // New user, display coupon
                const couponCode = response.data.couponCode;
                document.getElementById("coupon-code").textContent = couponCode;
                document.getElementById("coupon-container").style.display = "block";
                showApp();
               localStorage.setItem("isLoggedIn", "true");
                alert("Here is your coupon code!");
            }
        } else {
            alert(response.data.message || "An error occurred.");
        }
    } catch (error) {
        console.error("Error:", error);
        alert("Failed to process your request. Please try again later.");
    }
});

// Copy coupon code to clipboard
document.getElementById("coupon-code").addEventListener("click", function() {
    const couponCode = this.textContent;

    navigator.clipboard.writeText(couponCode)
        .then(() => {
            alert(`Coupon code "${couponCode}" copied to clipboard!`);
        })
        .catch(err => {
            console.error("Failed to copy:", err);
            alert("Could not copy the coupon code. Please try again.");
        });
});

// Close button functionality
document.getElementById('close-btn').addEventListener('click', function() {
    hideApp();
});

// Run login status check on page load
checkLoginStatus();
